// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"747":"41d75eeb1944b3ec","790":"1aee8aa6d88bca60"}[chunkId] + ".chunk.js";
};